import Image from 'next/image';
import { getContentImageProps } from '@/lib/utils';
import Link from 'next/link';

const GoArrow = ({ color }) => {
  return (
    <svg
      enableBackground="new 0 0 24 24"
      height="24"
      width="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className="mr-2.5 self-center"
      aria-hidden="true"
    >
      <g
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="m3 12h18" />
        <path d="m16 7 5 5-5 5" />
      </g>
    </svg>
  );
};

export default async function FullMediaTextBox({ block, position }) {
  const {
    title,
    _metadata,
    description,
    logo,
    link_text,
    link,
    image,
    mobile_image,
    text_color,
    text_box_background_color
  } = block;

  const { srcSet: desktopSrcSet } = getContentImageProps({
    image: image,
    sizes: '100vw'
  });
  const { srcSet: mobileSrcSet, remainingProps } = getContentImageProps({
    image: mobile_image,
    sizes: '100vw'
  });

  return (
    <section
      id={_metadata.uid + '_' + position}
      data-name="editorial-full-media-textbox"
      className={`text-[${text_color}] relative`}
    >
      <div className="w-full">
        <picture className="">
          <source media="(min-width: 640px)" srcSet={desktopSrcSet} />
          <source srcSet={mobileSrcSet} />
          <img
            {...remainingProps}
            className="block h-90 w-full object-cover sm:h-155 lg:h-155.5"
            alt={image.title.replace(/\.[^/.]+$/, '')}
          />
        </picture>
        <div
          className={`block w-full px-5 py-10 sm:px-20 lg:absolute lg:right-0 lg:bottom-0 lg:w-120 lg:px-10 bg-[${text_box_background_color}] justify-items-center text-center lg:justify-items-start lg:text-start`}
        >
          {logo?.url && (
            <div className="mb-5 lg:mb-10">
              <Image
                src={logo.url}
                width={214}
                height={20}
                sizes="214px"
                alt={logo.title.replace(/\.[^/.]+$/, '')}
                className="mx-auto max-h-4 sm:mx-0 lg:max-h-5"
              />
            </div>
          )}
          <div>
            {title && <h2 className="h4 sm:h3 lg:h2">{title}</h2>}
            {description && (
              <p className="body-r sm:body-l my-5">{description}</p>
            )}
            {link[0] && (
              <div className="flex justify-center pt-3 lg:justify-start lg:pt-5">
                <Link
                  href={link[0].url}
                  id={link[0].uid + '_' + position}
                  prefetch={false}
                  className="flex items-center gap-2"
                >
                  <GoArrow color={text_color} />
                  <span
                    className={`h6 lg:h5 ${text_color == '#000000' ? 'txt-btn-secondary' : 'txt-btn-secondary-white'}`}
                  >
                    {link_text}
                  </span>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
